// extracted by mini-css-extract-plugin
module.exports = {"content":"main_content__vQqCg"};